import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";

import { InstallationMaalerAflaesningFormBuilder } from "@e-forsyning/common/maaler";
import { InstallationMaalerAflaesning, InstallationMaalerAflaesningMedMaalerType } from "@e-forsyning/common/maaler";

export class FeatureMaalerAflaesningFormBuilder {
    public static maalerAflaesningToFormGroup(maalerAflaesning: InstallationMaalerAflaesningMedMaalerType): UntypedFormGroup {
        const result = InstallationMaalerAflaesningFormBuilder.maalerAflaesningToFormGroup(maalerAflaesning, true);
        result.addControl("email", new UntypedFormControl(null, Validators.email));
        return result;
    }

    public static formGroupToMaalerAflaesning(formGroup: UntypedFormGroup): {
        maalerAflaesning: InstallationMaalerAflaesning;
        email: string;
    } {
        const maalerAflaesning = InstallationMaalerAflaesningFormBuilder.formGroupToMaalerAflaesning(formGroup);
        const email = formGroup.get("email").value;
        return { maalerAflaesning, email };
    }
}
